import { Diamond } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { C } from "@/data/content";

export default function Marquee() {
    const { L } = useLanguage();
    const items = L(C.marquee.items);

    const Row = () => (
        <div className="flex shrink-0 items-center">
            {items.map((it, i) => (
                <span key={i} className="flex items-center">
                    <span className="font-display whitespace-nowrap px-8 text-lg text-txt-2 sm:text-xl">
                        {it}
                    </span>
                    <Diamond className="size-2.5 text-brass" fill="currentColor" />
                </span>
            ))}
        </div>
    );

    return (
        <section
            dir="ltr"
            data-testid="trade-marquee"
            className="marquee relative overflow-hidden border-y border-gold-line/60 bg-ink-2/60 py-5"
        >
            <div className="marquee-track">
                <Row />
                <Row />
            </div>
        </section>
    );
}
